var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pointer"},[_vm._t("default",null,{"copied":_vm.copied,"copy":_vm.copy,"icon":_vm.icon}),(!_vm.hideIcon)?_c('v-icon',[_vm._v(_vm._s(_vm.icon))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }